"use client";

import { usePathname } from "next/navigation";

export default function LayoutWrapper({ children, header, footer, breadcrumb }) {
    const pathname = usePathname();
    const isPanel = pathname?.startsWith('/panel') || pathname?.startsWith('/admin');

    if (isPanel) {
        return <>{children}</>;
    }

    return (
        <div className="page-shell">
            {header}
            {breadcrumb}
            <main dir="rtl" lang="fa" className="space-y-12 sm:space-y-16 lg:space-y-24 container-4xl max-md:px-4">
                {children}
            </main>
            {footer}
        </div>
    );
}
